<div class="cluster-map-marker-wrapper">
    @if (numberOfProjects() === 1) {
    <div class="price-cluster-wrapper single-project">
        <div class="project-icon"></div>
        <div class="price-cluster-price-range">
            <div class="">{{ projectNameOrGeneralText() }}</div>
        </div>
    </div>
    }@else {
    <div class="price-cluster-wrapper">
        <div class="price-cluster-counter">{{ numberOfProjects() || 0 }}</div>
        <div class="price-cluster-price-range">
            <div class="">{{ projectNameOrGeneralText() }}</div>
        </div>
    </div>
    }
</div>
